<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "MaklerHinweis",
  components: {},
});
</script>

<template>
  <p>Online können wir Ihnen kein Angebot erstellen.</p>
  <p>
    Bitte rufen Sie im Maklervertriebscenter unter der Telefonnummer 040 3766 3222 an. Sie erreichen uns von Montag bis
    Freitag von 8:00 bis 18:00 Uhr.
  </p>
</template>

<style scoped></style>
